/**
 * presentationTimelineService.ts
 *
 * Firestore CRUD for physical presentation timelines.
 * Each entity (club) has one timeline document in meetingPresentationTimelines/{entityId}.
 */

import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase';
import { COLLECTIONS } from './meetingConstants';
import type { PresentationSlot, PresentationTimeline } from './networkClubTypes';

const COL = COLLECTIONS.PRESENTATION_TIMELINES;

export async function loadPresentationTimeline(
  entityId: string,
): Promise<PresentationTimeline | null> {
  const snap = await getDoc(doc(db, COL, entityId));
  if (!snap.exists()) return null;
  return { entityId, ...snap.data() } as PresentationTimeline;
}

export async function savePresentationTimeline(
  entityId: string,
  slots: PresentationSlot[],
  totalPages: number,
): Promise<void> {
  await setDoc(
    doc(db, COL, entityId),
    { entityId, slots, totalPages, updatedAt: serverTimestamp() },
    { merge: true },
  );
}
